export default {
      id: "small-burger-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-burger",
      toString: function () {
        return this.url;
      }
    }